import { httpInstance as http } from "@/plugins/http";
import endpoints from "@/api/endpoints";

async function request(method, url, data) {
  const response = await http[method](url, data);
  if (!response || response.status > 299) {
    throw new Error(
      response?.data?.message || "The request failed. Please try again."
    );
  }
  return response.data;
}

export const listComponents = (params) =>
  request("get", endpoints.COMPONENTS, { params });
export const getComponentTypes = () =>
  request("get", endpoints.COMPONENT_TYPES);
export const getInventory = (id) =>
  request("get", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}`);
export const setInventoryOwnership = (id, ownerCompanyId) =>
  request("post", endpoints.PRO_CAMERA_OWNERSHIP(id), { owner_company_id: ownerCompanyId });
export const allocateInventory = (id, companyId) =>
  request("post", endpoints.DEVICE_ALLOCATION(id), { company_id: companyId });
export const getComponent = (id, params) =>
  request("get", `${endpoints.COMPONENTS}/${id}`, { params });
export const saveComponent = ({ id, data, inventoryId }) =>
  request(
    id ? "patch" : "post",
    id
      ? `${endpoints.COMPONENTS}/${id}`
      : inventoryId
      ? `${endpoints.PRO_CAMERA_INVENTORIES}/${inventoryId}/components`
      : endpoints.COMPONENTS,
    data
  );
export const deleteComponent = (id) =>
  request("delete", `${endpoints.COMPONENTS}/${id}`);
export const getInventoryComponents = (id, params) =>
  request("get", `${endpoints.PRO_CAMERA_INVENTORIES}/${id}/components`, {
    params,
  });
export const installComponent = ({ inventoryId, componentId, note }) =>
  request(
    "post",
    `${endpoints.PRO_CAMERA_INVENTORIES}/${inventoryId}/installations`,
    { component_id: componentId, note }
  );
export const removeComponent = ({
  inventoryId,
  installationId,
  reason,
  note,
}) =>
  request(
    "post",
    `${endpoints.PRO_CAMERA_INVENTORIES}/${inventoryId}/installations/${installationId}/remove`,
    { reason, note }
  );
